export function bindPrivacyPreferences({ document, getBanner, schedule = setTimeout, cancel = clearTimeout }) {
  const attempts = new WeakMap();
  const onClick = event => {
    const button = event.target?.closest?.('[data-bb-privacy-open]');
    if (!button || !document.contains(button) || button.disabled) return;
    const controls = button.closest('[data-bb-privacy-preferences]');
    const status = controls?.querySelector('[data-bb-privacy-status]');
    if (!status) return;
    status.hidden = true;
    let banner, showPreferences;
    try { banner = getBanner(); showPreferences = banner?.showPreferences; } catch { status.hidden = false; return; }
    if (typeof showPreferences !== 'function') { status.hidden = false; return; }
    const attempt = {};
    attempts.set(button, attempt);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const finish = failed => {
      if (attempts.get(button) !== attempt) return;
      attempts.delete(button);
      cancel(attempt.timer);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      status.hidden = !failed;
    };
    attempt.timer = schedule(() => finish(true), 8000);
    try { Promise.resolve(Reflect.apply(showPreferences, banner, [])).then(() => finish(false), () => finish(true)); }
    catch { finish(true); }
  };
  document.addEventListener('click', onClick);
  return () => document.removeEventListener('click', onClick);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  bindPrivacyPreferences({ document, getBanner: () => window.privacyBanner });
}
